import type { CurrencyAmount, Token } from '@uniswap/sdk-core'
import { formatUnits, type Hex, hexToBigInt, isHex, parseUnits } from 'viem'

export function amount_to_tokens(
  amount: bigint | undefined | Hex,
  decimals: number,
): number {
  if (amount == null) return 0

  if (isHex(amount)) {
    amount = hexToBigInt(amount)
  }

  return Number(formatUnits(amount, decimals))
}

export function tokens_to_amount(
  tokens: number | string,
  decimals: number,
): bigint {
  return parseUnits(String(tokens), decimals)
}

/** a range-1-number percentage in the form X/(10**27),
 *  where X is a range-(10**27)-bigint,
 *  range-100-number as X/PERCENTAGE_PRECISION */
const PERCENTAGE_PRECISION = BigInt('1' + '0'.repeat(25))

/** maximum safe number of fractional digits for a Number for our conversions */
const DECIMAL_MAX_DIGITS = Math.floor(Math.log10(Number.MAX_SAFE_INTEGER))
const DECIMAL_MAX_SCALE = BigInt(Math.pow(10, DECIMAL_MAX_DIGITS))

/** decodes an encoded percentage from range-(10**27)-bigint into a range-100-number */
export function encoded_to_percentage(value: bigint): number {
  return (
    Number((value * DECIMAL_MAX_SCALE) / PERCENTAGE_PRECISION) /
    Number(DECIMAL_MAX_SCALE)
  )
}

/** encodes a percentage from range-100-number into a range-(10**27)-bigint  */
export function percentage_encoded(value: number): bigint {
  return (
    (BigInt(value * Number(DECIMAL_MAX_SCALE)) * PERCENTAGE_PRECISION) /
    BigInt(DECIMAL_MAX_SCALE)
  )
}

export function findCurrencyAmount({
  symbol,
  pair,
  not = false,
}: {
  symbol: string
  pair: [CurrencyAmount<Token>, CurrencyAmount<Token>]
  not?: boolean
}): CurrencyAmount<Token> {
  if (not) {
    return pair[0].currency.symbol === symbol ? pair[1] : pair[0]
  }
  return pair[0].currency.symbol === symbol ? pair[0] : pair[1]
}

export function to_decimal_scale(decimal: number): bigint {
  return BigInt(Math.pow(10, decimal))
}
